/**
 * Newsletter Form Handler
 *
 * Handles form submission and validation for newsletter signup
 */

import { getRecaptchaToken } from "./recaptcha";
import { initFormConsentOverlay } from "./gdpr-consent";

export function initNewsletterForm() {
  const form = document.getElementById("newsletter-form") as HTMLFormElement;
  if (!form) return;

  initFormConsentOverlay(form);

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // Check if form is valid using HTML5 validation
    if (!form.checkValidity()) {
      // Trigger native validation UI
      form.reportValidity();
      return;
    }

    const submitButton = form.querySelector(
      'button[type="submit"]',
    ) as HTMLButtonElement;
    const messagesDiv = document.getElementById("newsletter-messages");
    const messageContent = messagesDiv?.querySelector(".message-content");

    if (!submitButton || !messagesDiv || !messageContent) return;

    // Disable submit button
    submitButton.disabled = true;
    submitButton.textContent = "Wird gesendet...";

    // Clear previous messages
    messagesDiv.classList.add("hidden");
    messageContent.className = "message-content p-4";

    // Get reCAPTCHA token
    const recaptchaToken = await getRecaptchaToken("newsletter_form");

    // Get form data
    const formData = new FormData(form);
    formData.append("action", "certlex_newsletter_submit");
    formData.append("nonce", (window as any).certlex_ajax?.nonce || "");
    formData.append("recaptcha_token", recaptchaToken);

    try {
      const response = await fetch(
        (window as any).certlex_ajax?.url || "/wp-admin/admin-ajax.php",
        {
          method: "POST",
          body: formData,
        },
      );

      const data = await response.json();

      // Show message
      messagesDiv.classList.remove("hidden");

      if (data.success) {
        messageContent.classList.add(
          "bg-green-100",
          "text-green-800",
          "border",
          "border-green-200",
        );
        messageContent.textContent = data.data;
        form.reset();
      } else {
        messageContent.classList.add(
          "bg-red-100",
          "text-red-800",
          "border",
          "border-red-200",
        );
        messageContent.textContent = data.data || "Ein Fehler ist aufgetreten.";
      }
    } catch (error) {
      messagesDiv.classList.remove("hidden");
      messageContent.classList.add(
        "bg-red-100",
        "text-red-800",
        "border",
        "border-red-200",
      );
      messageContent.textContent =
        "Verbindungsfehler. Bitte versuchen Sie es später erneut.";
    } finally {
      // Re-enable submit button
      submitButton.disabled = false;
      submitButton.textContent = "Absenden";
    }
  });
}
